module.exports = __webpack_public_path__ + "img/activate.afe651ab.svg";